import { Callout, Classes, Intent, Label } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import {
  EditableLabel,
  EditableLabelProps,
} from 'src/components/EditableLabel';

export const InlineEditableLabel = ({
  disabled = false,
  label,
  onValidate,
  testId,
  value,
  ...editableLabelProps
}: EditableLabelProps & {
  disabled?: boolean;
  label: React.ReactNode;
  testId?: string;
}) => {
  const [invalid, setInvalid] = React.useState('');

  const handleValidate = React.useCallback(
    (newLabel: string) => {
      const message = onValidate?.(newLabel) ?? '';

      setInvalid(message);

      return message;
    },
    [onValidate]
  );

  return (
    <Label
      className={classNames(
        'sd-drawer-editable-label',
        'sd-drawer-editable-label--inline',
        {
          [Classes.TEXT_DISABLED]: disabled,
          'sd-drawer-editable-label--multiline': editableLabelProps.multiline,
        }
      )}
      data-testid={testId}
    >
      <span>{label}</span>
      <Callout
        icon={null}
        intent={invalid !== '' ? Intent.DANGER : Intent.NONE}
      >
        <EditableLabel
          disabled={disabled}
          monospaceText
          onValidate={onValidate ? handleValidate : undefined}
          setValueOnChange
          value={value}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...editableLabelProps}
        />
      </Callout>
    </Label>
  );
};
